export const formatDate = (inputDate) => {
  const formattedDatePattern = /^\d{2}-[A-Za-z]{3}-\d{4}$/;

  // If the input is already in the desired format, return it as is
  if (typeof inputDate === "string" && formattedDatePattern.test(inputDate)) {
    return inputDate;
  }

  // If the input is invalid, return an empty string
  if (!inputDate || !(inputDate instanceof Date) || isNaN(inputDate)) {
    return "";
  }

  // Format the date as dd-MMM-yyyy
  const day = String(inputDate.getDate()).padStart(2, "0");
  const month = inputDate.toLocaleString("en-GB", { month: "short" });
  const year = inputDate.getFullYear();

  return `${day}-${month}-${year}`;
};
